module.exports = __webpack_public_path__ + "dk.svg?6227fcc5447bbd9d36b0cdfd2ea0c33c";